export const tabview = {
    root: {
        className: ''
    },
    navContent: {
        className: 'border-0'
    },
    inkbar: {
        className: 'text-[var(--primary-color)]'
    },
    nav: {
        className: 'flex-col sm:flex-row flex text-sm border-b border-gray-300 nav-ul'
    },
    tab: {
        className: 'border-b border-gray-300'
    }
    // panelContainer:{
    //   className:'p-0'
    // }
}